import { styled } from '@mui/material/styles';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

const CustomDateCalendar = styled(DateCalendar)<any>`
  margin: 0;
  width: 100%;
  & .MuiTypography-root {
    color: #575757;
    font-weight: 600;
    width: 14.2857143%;
    border-radius: 24px;
    font-size: 14px;
  }
  & .MuiButtonBase-root {
    width: 14.2857143%;
    border-radius: 24px;
    font-size: 14px;
    font-weight: 400;
  }

  & .MuiPickersDay-root,
  .MuiBadge-root {
    width: 14.2857143%;
    border-radius: 24px;
  }
  & .MuiPickersCalendarHeader-label {
    font-size: 16px;
    font-weight: 700;
  }
  .MuiSvgIcon-root {
    width: 1.5em;
    height: 1.5em;
  }
  
  @media (max-width: 768px) {
    .MuiSvgIcon-root {
      width: 1.2em;
      height: 1.2em;
    }
    .MuiPickersCalendarHeader-label {
      font-size: 16px;
      font-weight: 600;
    }
    & .MuiTypography-root,
    & .MuiButtonBase-root {
      font-size: 12px;
      min-height: 32px;
      height: 32px;
    }
    & .MuiPickersDay-root,
    .MuiBadge-root {
      font-size: 12px;
      min-height: 32px;
      height: 32px;
      width: 32px !important;
      margin: 1px;
      flex: none;
    }
    .MuiDayCalendar-weekDayLabel {
      font-size: 11px;
      height: 24px;
      width: 32px;
      font-weight: 600;
    }
    .MuiDayCalendar-header {
      margin-top: 8px;
      margin-bottom: 4px;
    }
    .MuiPickersArrowSwitcher-root {
      column-gap: 8px;
    }
    .MuiPickersCalendarHeader-root {
      padding: 12px 16px;
      min-height: 48px;
    }
    .MuiDayCalendar-monthContainer {
      margin: 4px 0;
    }
    .MuiDayCalendar-slideTransition {
      min-height: 240px;
    }
    .MuiDayCalendar-weekContainer {
      margin: 2px 0;
    }
    .MuiBadge-badge {
      left: 50% !important;
      top: 2px !important;
      right: auto !important;
      transform: translateX(-50%) !important;
      min-width: 8px !important;
      width: 8px !important;
      height: 8px !important;
      padding: 0 !important;
      padding-bottom: 2px !important;
      border-radius: 50% !important;
      font-size: 0 !important;
    }
    span.MuiBadge-badge.MuiBadge-standard.MuiBadge-anchorOriginTopRight.MuiBadge-anchorOriginTopRightCircular.MuiBadge-overlapCircular {
      width: 8px !important;
      height: 8px !important;
      min-width: 8px !important;
      padding: 0 !important;
      padding-bottom: 2px !important;
      left: 50% !important;
      top: 2px !important;
      right: auto !important;
      transform: translateX(-50%) !important;
      font-size: 0 !important;
    }
  }
  .MuiPickersArrowSwitcher-root {
    justify-content: center;
    column-gap: 10px;
  }
  .MuiYearCalendar-root {
    width: 100%;
  }
  .Mui-selected {
    background-color: #6586ff !important;
    &:hover {
      background-color: #6586ff !important;
    }
  }
  .MuiBadge-badge {
    left: 2px;
    top: 50%;
  }
  .MuiDayCalendar-weekDayLabel {
    color: var(--Neutral-20, var(--Primitives-Neutral-20, #202020));
    font-feature-settings: 'liga' off, 'clig' off;

    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 18.2px */
  }
  .MuiPickersDay-root {
    color: var(--Neutral-20, var(--Primitives-Neutral-20, #202020));
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 18.2px */
  }
  .css-1wy8uaa-MuiButtonBase-root-MuiPickersDay-root:hover {
    background: var(--Primitives-Neutral-80, #dcdcdc);
  }
  span.MuiBadge-badge.MuiBadge-standard.MuiBadge-anchorOriginTopRight.MuiBadge-anchorOriginTopRightCircular.MuiBadge-overlapCircular {
    width: 23px;
  }
  .MuiDayCalendar-header {
    margin-top: 10px;
  }
`;
export default CustomDateCalendar;
